<script>
    import { createEventDispatcher } from 'svelte';
    import Progress from './Progress.svelte';
    import {getCsrfToken, getSetting} from '../../utils.js';
    import {sgettext} from '../../i18n.js';

    export let multiple = true;
    export let id = 'fileUploader';
    export let uploadApi = '';
    export let accept = '.jpg,.jpeg,.png,.gif,.mp4';
    export let onUploaded = () => {};

    let fileInput = null;
    let fileText = multiple ? sgettext('$$FILES_1$$') : sgettext('$$FILE_1$$');
    let dragOver = false;

    let progress = 0;
    let uploadProgress = [];
    let showProgress = false;
    let error = '';

    const dispatch = createEventDispatcher();

    function handleClick(){
        if(fileInput){
            fileInput.click();
        }
    }

    function initUploadProgress(totalFiles) {
        progress = 0;
        uploadProgress = [];

        for (let i = totalFiles; i > 0; ) {
            uploadProgress.push(0);
        }
    }

    function updateProgress(fileIndex, percent) {
        uploadProgress[fileIndex] = percent;
        progress =
            uploadProgress.reduce((total, current) => total + current, 0) /
            uploadProgress.length;
    }

    async function uploadMedia(file, i) {
        var extensions = file.name.toLowerCase().match(/\.\w+/gi);
        var isValid = false, extension = null
        if (extensions.length) {
            extension = extensions[extensions.length - 1];
            var validExtensions = accept.split(",");
            validExtensions.forEach(function(ext) {
                if (ext == extension) { isValid = true; }
            });
        }

        if (isValid) {
            //since we need to show upload progress we have to use XMLHttpRequest
            let url = uploadApi;
            if (window.location.host === 'localhost:5000') {
                url = `http://localhost:8000${uploadApi}`;
            }
            const xhr = new XMLHttpRequest();
            const formData = new FormData();
            let token = getSetting('jwt');
            showProgress = true;

            xhr.open('POST', url, true);

            if (token) {
                xhr.setRequestHeader('Authorization', `JWT ${token}`);
            } else {
                xhr.setRequestHeader('X-CSRFToken', getCsrfToken());
            }
            
            xhr.upload.addEventListener('progress', function(e) {
                updateProgress(i, (e.loaded * 100.0) / e.total || 100);
            });

            xhr.addEventListener('readystatechange', function(e) {
                if (xhr.readyState === 4 && xhr.status === 201) {
                    //file uploaded
                    showProgress = false;
                    error = '';
                    onUploaded(JSON.parse(xhr.responseText));

                    //update list with new media
                } else if (xhr.readyState === 4 && xhr.status != 201) {
                    //show error message
                    showProgress = false;
                    initUploadProgress(0);
                    error= sgettext('$$FILE_TRYING_UPLOAD_LARGE_KINDLY_UPLOAD$$')
                }
            });

            formData.append('media', file);
            xhr.send(formData);
        } else {
            dispatch('invalidFile', {
                fileName: file.name,
                extension: extension,
            });
        }
    }

    function onFileInputChange(event) {
        const files = event.currentTarget.files;
        if(files.length){
            handleMediaInputChanged(files);            
        }
    }

    function handleDragEnter(event) {
        dragOver = true;
    }

    function handleDragLeave(event) {
        dragOver = false;
    }

    function handleMediaInputChanged(files) {
        const fileArray = [...files];
        fileArray.forEach(uploadMedia);
    }

    function handleDrop(event) {
        dragOver = false;
        const files = event.dataTransfer.files;

        if (files.length) {
            handleMediaInputChanged(files);
        }
    }

    function handleDragOver(event) {
        // required so that browser will not open the media
        dragOver = true;
    }
</script>

<style>
    .hidden {
        display: none;
    }

    .file-uploader {
        height: 100px;
        border: 2px dashed #ced4da;
        margin-top: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        flex-direction: column;
    }

    .file-uploader.drag-over {
        border: 2px dashed #0a6cb4;
        background-color: rgba(0, 153, 204, 0.2);
    }

    .file-uploader :global(.progress) {
        width: 100%;
    }

    .placeholder {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .file-uploader-error {
        position: relative;
        top: 10px;
    }
</style>

<div
    class="file-uploader"
    class:drag-over={dragOver}
    on:click={handleClick}
    on:dragenter|preventDefault|stopPropagation={handleDragEnter}
    on:dragleave|preventDefault|stopPropagation={handleDragLeave}
    on:dragover|preventDefault|stopPropagation={handleDragOver}
    on:drop|preventDefault|stopPropagation={handleDrop}>
    <input
        {id}
        bind:this={fileInput}
        class="hidden"
        type="file"
        {multiple}
        {accept}
        on:change={onFileInputChange} />

    <div class="placeholder">
        {sgettext('$$DRAG_DROP$$')} {fileText} {sgettext('$$BEGIN_UPLOAD_CLICK_BROWSE$$')} {fileText}.
    </div>
    <div>
        <h5 class="mb-1">{sgettext('$$SUPPORTS$$')} <strong>{accept}</strong></h5>
    </div>
    {#if showProgress}
    <Progress value={progress} />
    {/if}
</div>
{#if error}
   <div class="text-danger file-uploader-error">{sgettext(error)}</div>
{/if}